import React from 'react';

/* ================= COMPONENTS ================= */

const PolicyCard = ({ id, title, children }) => (
  <section
    id={id}
    className="bg-[#fbfcf3] shadow-xl rounded-2xl p-8 md:p-12 border border-gray-200 hover:shadow-2xl transition duration-500"
  >
    <h2 className="text-2xl md:text-3xl font-light mb-4">{title}</h2>
    <div className="w-full h-px bg-gray-900 mb-6"></div>

    <div className="text-gray-700 space-y-4 leading-relaxed">
      {children}
    </div>
  </section>
);

const List = ({ items }) => (
  <ul className="list-disc ml-6 space-y-2">
    {items.map((item, i) => (
      <li key={i}>{item}</li>
    ))}
  </ul>
);

/* ================= PAGE ================= */

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#f5f6ed] text-gray-900">

      {/* ===== HEADER ===== */}
      <div className="pt-32 pb-20 px-6 text-center">
        <h1 className="text-5xl md:text-6xl font-light mb-6">
          Privacy Policy – Cognitics
        </h1>
        <p className="text-gray-600">Last updated: [01-01-2026]</p>
      </div>

      {/* ===== MAIN LAYOUT ===== */}
   <div className="max-w-6xl mx-auto px-6 pb-32">

  <div className="space-y-12">



          {/* INTRO */}
          <PolicyCard id="intro" title="Introduction">
            <p>
              At Cognitics, privacy is a core principle. This Privacy Policy explains how we collect, use, and protect your data.
            </p>
          </PolicyCard>

          {/* COLLECTION */}
          <PolicyCard id="collection" title="1. Information We Collect">

            <List items={[
              "Basic user information (email, name if provided)",
              "Usage data (interactions, logs)",
              "Research-related anonymized data"
            ]} />

            <p className="pt-4 font-medium">
              We do not sell personal data.
            </p>

          </PolicyCard>

          {/* USAGE */}
          <PolicyCard id="usage" title="2. Use of Information">
            <List items={[
              "Improve our products and research",
              "Understand system performance",
              "Support research insights (anonymized)"
            ]} />
          </PolicyCard>

          {/* MENTAL HEALTH */}
          <PolicyCard id="mental" title="3. Mental Health Data">

            <p>Any mental health-related data is:</p>

            <List items={[
              "Handled with strict confidentiality",
              "Stored securely",
              "Used only for research or product improvement",
              "Never shared with third parties without consent"
            ]} />

          </PolicyCard>

          {/* SECURITY */}
          <PolicyCard id="security" title="4. Data Security">
            <p>
              We implement industry-standard security practices to protect your data from unauthorized access or misuse.
            </p>
          </PolicyCard>

          {/* SHARING */}
          <PolicyCard id="sharing" title="5. Data Sharing">
            <p>
              We may share anonymized and aggregated data with research partners strictly for academic or scientific purposes.
            </p>
          </PolicyCard>

          {/* RIGHTS */}
          <PolicyCard id="rights" title="6. Your Rights">
            <p>You may request:</p>
            <List items={[
              "Access to your data",
              "Correction or deletion",
              "Withdrawal of consent"
            ]} />
          </PolicyCard>

          {/* POLICY UPDATE */}
          <PolicyCard id="updates" title="7. Changes to Policy">
            <p>
              We may update this Privacy Policy periodically. Updates will be reflected on this page.
            </p>
          </PolicyCard>

        </div>
      </div>

    </div>
  );
}
